import Box from '@mui/material/Box';
export default Box;
